// @ts-nocheck
import React, { FC, useState, useRef, useEffect } from 'react';
import { whichAuth as getAuth } from '../../getAuth';
import { userState, showPoAState } from '../../atoms';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { handleErrors } from '../../utils/handleErrors';
import { format } from 'date-fns'
import DatePicker from 'react-date-picker'
import {
  IonModal,
  IonLabel,
  IonInput,
  IonButton,
  IonSpinner,
  IonGrid,
  IonRow,
  IonCol,
} from '@ionic/react';
import './PoA.css'
import AddressAutoComplete from '../AddressAutocomplete';
import AlertModal from "../AlertModal";

const PoA: FC = () => {
  
  const user = useRecoilValue(userState);
  const showPoA = useRecoilValue(showPoAState);
  
  const setUser = useSetRecoilState(userState);
  const setShowPoA = useSetRecoilState(showPoAState);
  

  const [userName, setUserName] = useState<string>(user.name);
  const [userAddress, setUserAddress] = useState<string>(user.address);
  const [userDoB, setUserDoB] = useState<string>(user.dateOfBirth || '1980-12-31T00:00:00.000Z');
  const [signingInProgress, setSigningInProgress] = useState<boolean>(false);
  // const [providerAccounts, setProviderAccounts] = React.useState({});
  
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [modalMessage, setModalMessage] = useState<string>('');
  const [modalTitle, setModalTitle] = useState<string>('');

  const customDatetime = useRef();
  const dobModal = useRef<HTMLIonModalElement>(null)

  useEffect(() => {
    if (user?.name) {
      setUserName(user?.name)
    }
    if (user?.address) {
      setUserAddress(user?.address)
    }
  }, [user?.name, user?.address])
  
  const updateUserAndCratePoA = () => {
    setSigningInProgress(true);
    
    getAuth().currentUser.getIdToken().then(token => {
      // update provider account numbers
      // Object.keys(providerAccounts).map(providerId => {
      //   return fetch(REST_API_URL + '/invoiceRedirects/' + user.id + "_" + providerId, {
      //     method: 'PATCH',
      //     body: JSON.stringify({account: providerAccounts[providerId]}),
      //     headers: {
      //       'Authorization': 'Bearer ' + token,
      //       'Content-Type': 'application/merge-patch+json'
      //     }
      //   })
      //   .then(handleErrors)
      //   .catch(() => console.error('Failed to update account number for provider ID ' + providerId));
      // })

      // update user information
      return fetch(user._links.self.href, {
          method: 'PATCH',
          body: JSON.stringify({
            name: userName,
            address: userAddress,
            dateOfBirth: userDoB
          }),
          headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/merge-patch+json'
          }
        })
        .then(handleErrors)
        .then(updatedUser => setUser({
          ...user,
          ...updatedUser
        }))
        .then(() => fetch(user._links.self.href + '/sign-poa', {headers: {'Authorization': 'Bearer ' + token}})
          .then(response => {
            if(response.status === 200) {
              setIsOpenModal(true)
              setModalTitle('Authorisation sent');
              setModalMessage('To complete your bill redirect request, please sign the request we sent to ' + user.email);
              // TODO: ping for completed signature  
            } else if(response.status === 204) {
              setIsOpenModal(true)
              setModalTitle('Authorisation completed');
              setModalMessage('You have already signed the authorisation for your selected providers. We will notify you once your billing email address has been updated.');
            } else {
              throw Error('Failed to create authorization');
            }
          })
          .catch(() => {
            setIsOpenModal(true)
            setModalTitle('Failed to create authorization');
            setModalMessage('Failed to create authorization. Please try again or contact us.');
          }))
        .catch(() => {
          setIsOpenModal(true)
          setModalTitle('Failed to process authorization request');
          setModalMessage('Failed to process authorization request. Please try again or contact us.');
        })
        .finally(() => setSigningInProgress(false));
    });
  }

  return (
    <IonModal isOpen={showPoA} onDidDismiss={() => setShowPoA(false)} className="poa-modal">
      <IonGrid className="poa-content">
        <IonRow>
          <IonCol size="12" className="settings-col">
            <IonLabel className="settings-col-title">Full name</IonLabel>
            <IonInput
              name="username"
              className="settings-content-input active"
              type="text"
              placeholder="Sarah Jones"
              value={userName}
              onIonInput={event => {let target:any = event.currentTarget; setUserName(target.value)}}
              onIonChange={event => setUserName(event.detail.value!)}
            />
          </IonCol>
          <IonCol size="12" className="settings-col">
            <IonLabel className="settings-col-title">Address</IonLabel>
            <AddressAutoComplete disabled={false}
              initialAddress={userAddress}
              onAddressUpdate={address => setUserAddress(address)} />
          </IonCol>
          <IonCol size="12" className="settings-col">
            <IonLabel className="settings-col-title">Date of Birth</IonLabel>
          </IonCol>
          <IonCol size="12" className="settings-col">
            <DatePicker
              value={new Date(userDoB)}
              clearIcon={false}
              calendarIcon={false}
              allowPartialRange={false}
              format="dd/MM/yyyy"
              minDate={new Date('01/01/1900')}
              onChange={(event) => setUserDoB(format(event, 'yyyy-MM-dd'))}
            />
          </IonCol>
          <IonCol size="12" className="settings-col">
            <IonButton
              onClick={() => updateUserAndCratePoA()}
              className="poa-button"
              disabled={signingInProgress || !userName || !userAddress}
            >
              { signingInProgress && <IonSpinner name="dots" /> }
              Next
            </IonButton>
            <IonButton onClick={() => setShowPoA(false)} className="poa-button cancel">
              Cancel
            </IonButton>
          </IonCol>
          <AlertModal
            isOpen={isOpenModal}
            title={modalTitle}
            subTitle={modalMessage}
            onClosed={() => {
              setIsOpenModal(false)
              if (modalMessage) {
                setShowPoA(false)
              }
            }}
          />
        </IonRow>
      </IonGrid>
      {/*{providers?.map(provider =>*/}
      {/*  <IonItem key={provider.id}>*/}
      {/*    <IonLabel style={{minWidth:'100px'}}>{provider.name}</IonLabel>*/}
      {/*    <IonInput placeholder="account or customer number"*/}
      {/*              value={providerAccounts[provider.id]}*/}
      {/*              onIonChange={event => setProviderAccounts({*/}
      {/*                ...providerAccounts,*/}
      {/*                [provider.id]: event.detail.value!*/}
      {/*              })}/>*/}
      {/*  </IonItem>)}*/}


    </IonModal>
  );
}

export default PoA;
